import { useCallback, useState } from 'react';
import { showPremiumModal } from '@components/features/modals/premium/PremiumModal';
import { GenericV1ErrorsArray } from '@type/v1-api-types';
import { baseURL } from '@root/src/utils';

export function useResumeAccessCheck(locale: Locale) {
  const [isChecking, setIsChecking] = useState(false);
  const [isAllowed, setIsAllowed] = useState(false);
  const apiURL = baseURL;

  const check = useCallback(async (slug: string) => {
    setIsChecking(true);
    setIsAllowed(false);

    try {
      const response = await fetch(`${apiURL}/v1/resume-operation/can-view-resume/${slug}`, {
        method: 'POST',
        headers: {
          'Accept-Language': locale,
        },
        credentials: 'include',
        body: JSON.stringify({
          userSlug: slug,
        }),
      });

      if (response?.ok) {
        setIsAllowed(true);
        return true;
      }

      const errorJson = (await response.json()) as GenericV1ErrorsArray;
      const code = errorJson?.errors?.[0]?.code;
      if (code === 805) {
        showPremiumModal(locale, '', 805);
      }
      setIsAllowed(false);
      return false;
    } finally {
      setIsChecking(false);
    }
  }, [locale, apiURL]);

  return { isChecking, isAllowed, check };
}
